import { Box, BoxProps } from "@chakra-ui/react";
import { FiChevronUp } from "react-icons/fi";

export const ChevronUp = (props: BoxProps) => {
  return <Box as={FiChevronUp} height="20px" width="20px" {...props} />;
};
